// Contains data transformation methods for Excel/PPT exports

import * as _ from 'lodash';

export class ExportDataFormatterHelper {
  /**
   * Prepares Excel data for Multiple Brands or Multiple Markets comparison
   * @param data Export data object
   * @returns Formatted data with processed outputTrendArray
   */
  static preapreexceldata(data: any): any {
    // let outputTrendArray = JSON.parse(data.outputTrendArray)[0];
    let outputTrendArray = JSON.parse(data.outputTrendArray);
    outputTrendArray = _.sortBy(outputTrendArray, 'previewChartPostion');
    let formetterdata = [];
    for (let i = 0; i < outputTrendArray.length; i++) {
      let currentwightdat = outputTrendArray[i];
      let custumization = JSON.parse(
        currentwightdat.customizationProperties || '{}'
      );
      for (let x = 0; x < currentwightdat.metric.length; x++) {
        for (
          let j = 0;
          j < currentwightdat.metric[x].metric_value.length;
          j++
        ) {
          let currentmetricdata = currentwightdat.metric[x].metric_value[j];
          for (let k = 0; k < currentmetricdata.data.length; k++) {
            let obj: any = {};
            obj.widget_name = currentwightdat.widget_name;
            obj.widgetchart_name = currentwightdat.widgetchart_name;
            obj.option = currentmetricdata.option;
            _.extend(obj, currentmetricdata.data[k]);
            obj.roundoffvalue = custumization.decimalRoundOff;
            formetterdata.push(obj);
          }
        }
      }
    }
    data.outputTrendArray = JSON.stringify(formetterdata);
    return data;
  }

  /**
   * Prepares Excel data for single brand/market comparison
   * Removes duplicate data entries using lodash uniqWith
   * @param data Export data object
   * @returns Formatted data with deduplicated outputTrendArray
   */
  static preapreexceldata1(data: any): any {
    let outputTrendArray = JSON.parse(data.outputTrendArray);

    for (let i = 0; i < outputTrendArray.length; i++) {
      let currentWidgetData = outputTrendArray[i];

      if (currentWidgetData.metric && currentWidgetData.metric.length) {
        for (let x = 0; x < currentWidgetData.metric.length; x++) {
          let currentMetric = currentWidgetData.metric[x];

          if (currentMetric.metric_value && currentMetric.metric_value.length) {
            for (let j = 0; j < currentMetric.metric_value.length; j++) {
              let currentMetricValue = currentMetric.metric_value[j];

              if (currentMetricValue.data && Array.isArray(currentMetricValue.data)) {
                currentMetricValue.data = _.uniqWith(currentMetricValue.data, _.isEqual);
              }
            }
          }
        }
      }
    }

    data.outputTrendArray = JSON.stringify([outputTrendArray]);

    return data;
  }

  /**
   * Prepares PPT data for Multiple Brands or Multiple Markets
   * Includes customization properties from newCustomizationData
   * @param data Export data object
   * @param newCustomizationData Customization data from config service
   * @returns Formatted data for PPT export
   */
  static preparePPTDataMultipleBrands(data: any, newCustomizationData: any): any {
    let outputTrendArray = JSON.parse(data.outputTrendArray);
    outputTrendArray = _.sortBy(outputTrendArray, 'previewChartPostion');
    let formetterdata = [];

    if (data.outputArray != null) {
      let outputArray = JSON.parse(data.outputArray);
      outputArray.forEach((itm: any) => {
        if (newCustomizationData != null) {
          let customization = _.filter(
            newCustomizationData,
            (x) => x.widget_name == itm.widget_name
          );
          if (customization != null && customization.length > 0) {
            itm.customizationProperties =
              customization[0].customizationProperties || '{}';
          }
        }
      });

      data.outputArray = JSON.stringify(
        JSON.parse(JSON.stringify(outputArray))
      );
    }
    for (let i = 0; i < outputTrendArray.length; i++) {
      let currentwightdat = outputTrendArray[i];
      let custumization = JSON.parse(
        currentwightdat.customizationProperties || '{}'
      );
      for (let x = 0; x < currentwightdat.metric.length; x++) {
        for (
          let j = 0;
          j < currentwightdat.metric[x].metric_value.length;
          j++
        ) {
          let currentmetricdata = currentwightdat.metric[x].metric_value[j];

          for (let k = 0; k < currentmetricdata.data.length; k++) {
            let obj: any = {};
            obj.widget_name = currentwightdat.widget_name;
            obj.widgetchart_name = currentwightdat.widgetchart_name;
            obj.roundoffvalue = custumization.decimalRoundOff;
            obj.option = currentmetricdata.option;
            _.extend(obj, currentmetricdata.data[k]);
            formetterdata.push(obj);
          }
        }
      }
    }
    data.outputTrendArrayforExcel = JSON.stringify(formetterdata);
    return data;
  }

  /**
   * Prepares PPT data for single brand/market
   * Applies customization and removes duplicates
   * @param data Export data object
   * @param newCustomizationData Customization data from config service
   * @returns Formatted data for PPT export
   */
  static preparePPTDataSingleBrand(data: any, newCustomizationData: any): any {
    let outputTrendArray = JSON.parse(data.outputTrendArray);
    let formetterdata = [];
    if (data.outputArray != null) {
      let outputArray = JSON.parse(data.outputArray);
      outputArray.forEach((itm: any) => {
        if (newCustomizationData != null) {
          let customization = _.filter(
            newCustomizationData,
            (x) => x.widget_name == itm.widget_name
          );
          if (customization != null && customization.length > 0) {
            itm.customizationProperties =
              customization[0].customizationProperties || '{}';
          }
        }
      });

      data.outputArray = JSON.stringify(
        JSON.parse(JSON.stringify(outputArray))
      );
    }
    for (let i = 0; i < outputTrendArray.length; i++) {
      let currentwightdat = outputTrendArray[i];
      for (let x = 0; x < currentwightdat.metric.length; x++) {
        for (
          let j = 0;
          j < currentwightdat.metric[x].metric_value.length;
          j++
        ) {
          let custumization = JSON.parse(
            currentwightdat.customizationProperties || '{}'
          );
          if (newCustomizationData != null) {
            let customization = _.filter(
              newCustomizationData,
              (x) => x.widget_name == currentwightdat.widget_name
            );
            if (customization != null && customization.length > 0) {
              outputTrendArray[i].customizationProperties =
                customization[0].customizationProperties || '{}';
            }
          }

          outputTrendArray[i].metric[x].metric_value[j].data = _.uniqWith(
            outputTrendArray[i].metric[x].metric_value[j].data,
            _.isEqual
          );
        }
      }
    }
    data.outputTrendArrayforExcel = JSON.stringify([outputTrendArray]);
    return data;
  }
}
